import { object, string } from 'yup';

export const LoginSchema = object().shape({
    email: string().email("Email is Invalid").required("Email is required"),
    password: string().min(6, "Password length is too short (min. 6 characters)").required("You can't login without a password"),
})